import Vue from "vue";
import Router from "vue-router";
import vueCookie from "vue-cookie"

Vue.use(Router);
//comment
// route-level code splitting
const LoginView = () => import("../views/auth/loginView.vue");
const MainDashboard = () => import("../views/dashboard/MainDashboard.vue");
const MainDashboardNew = () => import("../views/dashboard/MainDashboardNew.vue");
const Hospital = () => import("../views/hospital/Hospital.vue");
const Doctor = () => import("../views/Doctor/Doctor.vue");
const Support = () => import("../views/Chat/Chat.vue")
const Role = () => import("../views/role-manager/RoleManager.vue");
const Accounts = () => import("../views/Accounts/Account.vue");
const Settings = () => import("../views/Settings/Settings.vue");
const Reports = () => import("../views/Reports/Reports.vue");
// const SanarApp = () => import("../views/SanarAppUser/SanarAppUser.vue");
// const Reviews = () => import("../views/Reviews/Reviews.vue");
const Master = () => import("../views/Master/MasterView.vue");
const eClinicSequence = () => import("../views/Master/eClinicSequence.vue");
const Discount = () => import("../views/Discount/DiscountView.vue");
const Appointments = () => import("../views/appointments/Appointments.vue");
const MultiPatientAppointments = () => import("../views/appointments/MultiPatientAppointments.vue");
const Abandoned = () => import("../views/Abandoned/Abandoned.vue");
const ChangePassword = () => import("../views/auth/ChangePassword.vue");
const ForgotPassword = () => import("../views/auth/ForgotPassword.vue");
const UpdatePassword = () => import("../views/auth/UpdatePassword.vue");
const Package = () => import("../views/Packages/Packages.vue");
// const Coupon = () => import("../views/Coupon/Coupon.vue");
const SupplierCoupon = () => import("../views/SupplierCoupon/Coupon.vue");
const QitafEarnPoints = () => import("../views/Qitaf/QitafEarnPoints.vue");
const Settlements = () =>import("../views/Settlements/Settlements.vue");
const Cms =() =>import("../views/cms/Cms.vue");
const Enquiry = () => import("../views/Enquiry/Enquiry.vue");
// const Manualbooking = () => import("../views/manualbooking/Manualbooking.vue");
// Manual booking flow start here //
const ManualBookingFlow=() => import("../views/manualbooking/ManualBookingFlow.vue");
/* PSP flow start here */
const PSPTasks = () => import ("../components/manual-booking-flow/psp/PSPTaskFlow.vue")
const PSPBrowse =() => import("../views/manualbooking/psp/PSPBrowse.vue");
/*vitamin flow start here*/
const VitaminTasks = () => import("../components/manual-booking-flow/nurse/VitaminTaskFlow.vue");
/*nurse flow start here*/
const NurseTasks = () => import("../components/manual-booking-flow/nurse/NurseTaskFlow.vue");
const NurseBrowse =() => import("../views/manualbooking/nurse/NurseBrowse.vue");
/*Labtech flow start here*/
const LabTech = () => import("../components/manual-booking-flow/lab/SelectTestType.vue");
const LabBrowse =() => import("../views/manualbooking/lab/LabBrowse.vue");
const BupaOfflinePackages = () => import("../components/manual-booking-flow/bupaoffline/SelectTestType.vue");
const FluVaccination=()=>import("../components/manual-booking-flow/lab/FluVaccination.vue")
/*Physio flow start here*/
const TreatmentType=() => import("../views/manualbooking/physio/TreatmentType.vue");
const PhysioBrowse =() => import("../views/manualbooking/physio/PhysioBrowse.vue");
/*Homevisit flow start here*/
const Departments =() => import("../views/manualbooking/homevisit/Departments.vue");
const DoctorBrowse =() => import("../views/manualbooking/homevisit/DoctorBrowse.vue");
const InHouseClinicBooking =() => import("../views/manualbooking/homevisit/InHouseClinic.vue")
/*Video consultation flow start here*/
const Eclinic =() => import("../views/manualbooking/videoconsultation/Eclinic.vue");
const VideoBrowse =() => import("../views/manualbooking/videoconsultation/VideoBrowse.vue");
/*Add Details flow start here*/
const AddDetails=() => import("../views/manualbooking/add-details/AddDetails.vue");
const AddDetailsMulti=() => import("../views/manualbooking/add-details/AddDetailsMulti.vue");
const AddDetailsMultiBupa=() => import("../views/manualbooking/add-details/AddDetailsMultiBupa.vue");
// Manual booking flow end here //
//const PageNotFound = () => import("../views/common/404.vue"); 
// const MapView = () => import("../views/MapView.vue");
const Record = () => import("../views/record/Record.vue");
const Userflow = () =>import("../views/user-flow/Userflow.vue");
const Wallet =() =>import("../views/wallet/Wallet.vue");
const RateAndReview =()=>import("../views/rate-review/RateAndReview.vue");
const DashboardV3=()=>import('../views/dashboard-v3/DashboardV3.vue');
const RefferalOrders=()=>import('../views/refferalorders/RefferalOrders.vue')
// const SubscriptionDetails = () => import('../views/subscription-details/SubscriptionDetails.vue')
const menuItem = JSON.parse(localStorage.getItem('menu'))
let token = vueCookie.get('token')
const Tickets=()=>import('../views/pharmacy/tickets/Tickets.vue')
const Barq=()=>import('../views/pharmacy/barq/Barq.vue')
const PharmacyOrders=()=>import('../views/pharmacy/pharmacy-orders/PharmacyOrders.vue')
const PharmacyAbandoned =()=>import('../views/pharmacy/pharmacy-abandoned/PharmacyAbandoned.vue')
const Pharmacy=()=>import('../views/pharmacy/pharmacy-details/Pharmacy.vue')
const PharmacyAddDetails=()=>import('../views/manualbooking/add-details/PharmacyAddDetails.vue')
// const FamilyDoctor =()=>import('../views/familydoctor/FamilyDoctor.vue')
const FamilyDoctorDetails =()=>import('../views/family-doctor/FamilyDoctorDetails.vue')
const CaregiverAppointments=()=>import('../views/CaregiverAppointments/CaregiverAppointments.vue')
const Notifications=()=>import('../views/notificationstatus/Notifications.vue')
const CompanyDetails=()=>import('../views/companydetails/CompanyDetails.vue')
const LeadGeneration=()=>import('../views/leadgeneration/LeadGeneration.vue')
const BloodDonation=()=>import('../views/BloodDonation/BloodDonation.vue')
const BloodDonationDetails=()=>import('../views/BloodDonation/BloodDonationDetails.vue')
const Physiotherapy=()=>import('../views/physiotherapy/Physiotherapy.vue')
const NurseSubscriptionsDetails=()=>import('../views/NurseSubscriptions/NurseSubscriptionsDetails.vue')
const EmployeeStatus=()=>import('../components/notificationstatus/EmployeeStatus.vue')
const InHouseClinic=()=>import("../views/In-house-clinic/InHouseClinic.vue")
//const Practitioner=()=>import('../views/Practitioner/Practitioner.vue')
const ReferralRequest=()=>import('../views/ReferralRequest/ReferralRequest.vue')
const HomeCareMultiSession=()=>import('../views/home-care/HomeCareMultiSession.vue')
const MultisessionLaboratory=()=>import('../views/home-care/MultisessionLaboratory.vue')
const Captain=()=>import('../views/Captain/Captain.vue')
const RequestForms=()=>import('../views/RequestForms/RequestForms.vue')
const RateAndReviewV2 =()=>import("../views/dashboard-rate-review/RateAndReviewV2.vue");
const ShiftSummary =()=>import("../views/ShiftSummary/ShiftSummary.vue");
const PrescriptionDispenses = ()=>import("../views/PrescriptionDispenses/Dispenses.vue")
const MultiSessionSubscription = ()=>import("../views/MultiSessionSubscriptions/MultiSessionSubscriptions.vue")
const KidsVaccinationRequest = ()=>import("../views/KidsVaccinationRequests/KidsVaccinationRequests.vue")
const MultiSessionAbandoned =()=> import("../views/MultiSessionAbandoned/MultiSessionAbandoned.vue")
const Prescriptions =()=> import("../views/prescriptions/Prescriptions.vue")
const Offline =()=> import("../views/offline/Offline.vue")
const MultiSessionManagement = ()=>import("../views/MultiSessionManagement/MultiSessionManagement.vue")
const ChronicAppointment = () => import("../views/ChronicAppointments/ChronicAppointment.vue");
const DoctorAppointments = () => import("../views/DoctorAppointments/DoctorAppointments.vue");



const router = new Router({
    mode: "history",
    fallback: false,
    scrollBehavior: () => ({ y: 0 }),
    routes: [
      { path: "/", redirect: to => {
        // the function receives the target route as the argument
        // a relative location doesn't start with `/`
        // or { path: 'profile'}
        
        return (token && menuItem && menuItem[0].path) ? menuItem[0].path : '/login'
      }, name:"login" },
      { path: "/login", component: LoginView, name: "login", props: true },
      { path: "/old-dashboard", component: MainDashboard, name: "MainDashboard", meta:{auth:true} },
      { path: "/dashboard", component: DashboardV3, name: "DashboardV3", meta:{auth:true} },
      {path:"/dashboard-v2/" , component:MainDashboardNew, name:"MainDashboardNew" },
      { path: "/support", component: Support, name: "Support", meta:{auth:true} },
      { path: "/hospital/:action?/:utype?/:hspid?/:empid?", component: Hospital, name: "Hospital", meta:{auth:true} },
      { path: "/doctor/:action?/:uid?", component: Doctor, name: "doctor", meta:{auth:true} },
      { path: "/role-manager/:action?/:roleid?", component: Role, name: "Role", meta:{auth:true} },
      { path: "/settings/:action?", component: Settings, name: "Settings", meta:{auth:true} },
      { path: "/accounts/:action?/:hspid?", component: Accounts, name: "accounts", meta:{auth:true} },
      { path: "/reports/:action?/:store_id?", component: Reports, name: "reports", meta:{auth:true} },
      // { path: "/sanar-app-users/:action?", component: SanarApp, name: "SanarApp", meta:{auth:true} },
      // { path: "/reviews/:action?", component: Reviews, name: "Reviews", meta:{auth:true} },
      { path: "/appointments/multi-patient-appointments/:appid?", component: MultiPatientAppointments, name: "MultiPatientAppointments", meta:{auth:true} },
      { path: "/appointments/:action?/:appid?", component: Appointments, name: "Appointments", meta:{auth:true} },
      { path: "/Abandoned/:action?/:refid?", component: Abandoned, name: "Abandoned", meta:{auth:true} },
      // { path: "/mapview",  component: MapView, name: "mapview", props: true },
      { path: "/master",  component: Master, name: "master", meta:{auth:true} },
      { path: "/master/e-clinic-sequence",  component: eClinicSequence, name: "e-clinic-sequence", meta:{auth:true} },
      { path: "/package/:action?/:id?",  component: Package, name: "Package", meta:{auth:true} },
      { path: "/discount/:action?/:hspid?", component: Discount, name: "Discount", meta:{auth:true} },
      // { path: "/coupon/:action?/:id?", component: Coupon, name: "Coupon", meta:{auth:true} },
      { path: "/suppliercoupon/:action?/:id?", component: SupplierCoupon, name: "SupplierCoupon", meta:{auth:true} },
      { path: "/qitafearnpoints", component: QitafEarnPoints, name: "QitafEarnPoints", meta:{auth:true} },
      { path: "/accountreports/:action?/:id?", component: Settlements, name: "Settlements", meta:{auth:true} },
      { path: "/cms/:action?/:id?", component: Cms, name: "Cms", meta:{auth:true} },
      { path: "/cms/:action?/:dept_id?/:class_id?", component: Cms, name: "Cms", meta:{auth:true} },
      // { path: "/manualbooking/:action?", component: Manualbooking, name: "Manualbooking", meta:{auth:true} },
      { path: "/manual-booking-flow/:action?", component: ManualBookingFlow, name: "ManualBookingFlow", meta:{auth:true}, },
      /*vitamin iv flow start here*/
      { path: "/manual-booking-flow/book-appointment/vitamin-tasks", component: VitaminTasks, name: "vitaminTasks", meta:{auth:true} },
      /*nurse flow start here*/
      { path: "/manual-booking-flow/book-appointment/nurse-tasks", component: NurseTasks, name: "nurseTasks", meta:{auth:true} },
      { path: "/manual-booking-flow/book-appointment/nurse/nurse-browse", component: NurseBrowse, name: "NurseBrowse", meta:{auth:true} },
      /*PSP flow start here*/
      { path: "/manual-booking-flow/book-appointment/psp-tasks", component: PSPTasks, name: "pspTasks", meta:{auth:true} },
      { path: "/manual-booking-flow/book-appointment/psp/psp-browse", component: PSPBrowse, name: "PSPBrowse", meta:{auth:true} },
      /*Labtech flow start here*/
      { path: "/manual-booking-flow/book-appointment/labTech", component: LabTech, name: "labTech", meta:{auth:true} },
      { path: "/manual-booking-flow/book-appointment/bupa-offline-packages", component: BupaOfflinePackages, name: "BupaOfflinePackages", meta:{auth:true} },
      { path: "/manual-booking-flow/book-appointment/lab-browse", component: LabBrowse, name: "LabBrowse", meta:{auth:true} },
      { path: "/manual-booking-flow/book-appointment/flu-vaccination", component: FluVaccination, name: "fluVaccination", meta:{auth:true} },
      /*Physio flow start here*/
      {path: "/manual-booking-flow/book-appointment/treatment-type", component: TreatmentType, name: "TreatmentType", meta:{auth:true}},
      { path: "/manual-booking-flow/book-appointment/physio-browse", component: PhysioBrowse, name: "PhysioBrowse", meta:{auth:true} },
      /*Homevisit flow start here*/
      {path: "/manual-booking-flow/book-appointment/departments", component: Departments, name: "Departments", meta:{auth:true}},
      { path: "/manual-booking-flow/book-appointment/doctor-browse", component: DoctorBrowse, name: "DoctorBrowse", meta:{auth:true} },      
      {path: "/manual-booking-flow/book-appointment/in-house-clinic", component: InHouseClinicBooking, name: "InHouseClinic", meta:{auth:true}},
      /*Video consultation flow start here*/
      {path: "/manual-booking-flow/book-appointment/eclinic", component: Eclinic, name: "Eclinic", meta:{auth:true}},
      { path: "/manual-booking-flow/book-appointment/video-browse", component: VideoBrowse, name: "VideoBrowse", meta:{auth:true} },
      /*Add Details flow start here*/
      { path: "/manual-booking-flow/book-appointment/add-details", component: AddDetails, name: "AddDetails", meta:{auth:true} },
      { path: "/manual-booking-flow/book-appointment/add-details-multi", component: AddDetailsMulti, name: "AddDetailsMulti", meta:{auth:true} },
      { path: "/manual-booking-flow/book-appointment/add-details-multi-bupa", component: AddDetailsMultiBupa, name: "AddDetailsMultiBupa", meta:{auth:true} },
      // Manual booking flow end here //
      { path: "/record/:action?/:suid?", component: Record, name: "record", meta:{auth:true} },
      { path: "/userflow/:action?", component: Userflow, name: "userflow", meta:{auth:true} },
      {path:"/wallet/:action?",component:Wallet, name:"Wallet", meta:{auth:true}},
      {path:"/rate-and-review/:tabname/:action?/:appid?", component:RateAndReview, name:"RateAndReview", meta:{auth:true}},
      {path:"/dashboard/" , component:DashboardV3, name:"DashboardV3" },
      {path:"/referral-order" , component:RefferalOrders, name:"RefferalOrders" },
      // { path: "/subscription-details/:action?/:package_id?", component: SubscriptionDetails, name: "SubscriptionDetails"},
      {path:"/tickets/:action?/:tckt_id?" , component:Tickets, name:"Tickets" },
      {path:"/barq" , component:Barq, name:"Barq" },
      {path:"/pharmacy-orders/:action?/:order_id?" , component:PharmacyOrders, name:"PharmacyOrders" },
      {path:"/pharmacy-abandoned/:action?/:order_id?" , component:PharmacyAbandoned, name:"PharmacyAbandoned" },
      {path:"/pharmacy/:action?/:store_id?" , component:Pharmacy, name:"Pharmacy" },
      {path:"/add-details-pharmacy/:action?" , component:PharmacyAddDetails, name:"PharmacyAddDetails" },
      // {path:"/family-doctor/:action?/:subscription_id?" , component:FamilyDoctor, name:"FamilyDoctor"},
      {path:"/family-doctor-details/:action?/:sub_action?/:id?", component:FamilyDoctorDetails, name:"FamilyDoctorDetails"},
      {path:"/caregiver-appointments/:action?" , component:CaregiverAppointments, name:"CaregiverAppointments" },
      {path:"/notifications/:action?" , component:Notifications, name:"Notifications" },
      {path:"/company-details/:action?" , component:CompanyDetails, name:"CompanyDetails" },
      {path:"/lead-generation/:action?/:id?" , component:LeadGeneration, name:"LeadGeneration" },
      {path:"/blood-donation/:action?/:id?" , component:BloodDonation, name:"BloodDonation" },
      {path:"/lead-generation/:action?" , component:LeadGeneration, name:"LeadGeneration" },
      {path:"/blood-donation-details/:action?/:sub_action?/:id?", component:BloodDonationDetails, name:"BloodDonationDetails"},
      {path:"/physiotherapy-orders/:action?" , component:Physiotherapy, name:"Physiotherapy" },
      {path:"/nurse-subscriptions/:action?/:sub_action?/:id?", component:NurseSubscriptionsDetails, name:"NurseSubscriptionsDetails"},
      {path:"/employee-status/:action?" , component:EmployeeStatus, name:"EmployeeStatus" },
      {path:"/in-house-clinic/:action?" , component:InHouseClinic, name:"InHouseClinic" },
     // {path:"/practitioner/:action?/:id?", component:Practitioner, name:"Practitioner"},
      {path:"/referral-request/:action?/:id?", component:ReferralRequest, name:"ReferralRequest"},
      {path:"/home-care/:action?/:id?", component:HomeCareMultiSession, name:"HomeCareMultiSession"},
      {path:"/home-care-laboratory",component:MultisessionLaboratory,name:"MultisessionLaboratory"},
      {path:"/captain/:action?/:uid?", component:Captain, name:"Captain"},
      { path:"/request-form/:action?/:id?", component:RequestForms, name: "RequestForms", meta:{auth:true} },
      { path:"/rate-review-dashboard", component:RateAndReviewV2, name: "RateAndReviewV2", meta:{auth:true} },
      { path:"/shift-summary", component:ShiftSummary, name: "ShiftSummary", meta:{auth:true} },
      { path: "/prescription-dispenses/:action?/:id?", component: PrescriptionDispenses, name: "PrescriptionDispenses" },
      { path: "/multi-session-subscriptions/:action?", component: MultiSessionSubscription, name: "MultiSessionSubscription" },
      {path:"/kids-vaccination-requests/:action?" , component:KidsVaccinationRequest, name:"KidsVaccinationRequest" },
      { path: "/multi-session-abandoned/:action?", component: MultiSessionAbandoned, name: "MultiSessionAbandoned" },
      { path: "/prescription/:action?", component: Prescriptions, name: "Prescriptions" },
      { path: "/offline/:action?", component: Offline, name: "Offline" },
      { path: "/session-management/:action?", component: MultiSessionManagement, name: "MultiSessionManagement" },
      { path: "/chronic-appointments/:action?", component: ChronicAppointment, name: "ChronicAppointment"},
      { path: "/doctor-appointments/:action?", component: DoctorAppointments, name: "DoctorAppointment"},

       {
        path: "/change-password",
        component: ChangePassword,
        name: "change-password"
      },{
        path: "/forgot-password",
        component: ForgotPassword,
        name: "forgot-password",
        meta: {
          auth: true
        },
      },
      {
        path: "/set-password",
        component: UpdatePassword,
        name: "set-password"
      },
      { path: "/enquiry", component: Enquiry, name: "Enquiry", meta:{auth:true} },


      //{ path: "*", component: PageNotFound },
    ]
  });
  router.beforeResolve ((to, from, next) => {
   if(from.name && from.name.toLocaleLowerCase()!="rateandreview"){
    localStorage.setItem('pageNumber','1')
   }
    let token = vueCookie.get('token')
    if(token){
      let status = true;
      router.app.$store.dispatch('auth/UPDATE_LOGIN',{status, token})
    }else{
      let token = null, status = false;
      router.app.$store.dispatch('auth/UPDATE_LOGIN',{status, token})
    }
    let userInfo = JSON.parse(localStorage.getItem('userdetails'))
    if(userInfo) {
      router.app.$store.commit('auth/setUserData', userInfo)
    } else {
      console.log('no user')
      router.app.$store.commit('auth/setUserData', userInfo)
    }
    if (router.app.$store) {
      const isAuthRequired = to.meta.auth;
      let _token = router.app.$store.getters['auth/getToken'];
      if(isAuthRequired && !_token){
        setTimeout(function(){
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          if (to.name == 'forgot-password') {
            return next({
              name: 'forgot-password'
            })
          }
          else if (to.name == 'set-password') {
            return next({
              name: 'set-password'
            })
          }
          else {
            return next({
              name: 'login'
            })
          }
        },100)
      }
      if (to.name === 'login' && _token){
        setTimeout(function(){
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          return next({name:'dashboard'})
        },100)
      }if (to.name === 'forgot-password' && _token) {
        setTimeout(function () {
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          return next({
            name: 'dashboard'
          })
        }, 100)
      }
      if (to.name === 'set-password' && _token) {
        setTimeout(function () {
          router.app.$store.dispatch("SET_LAYOUT", to.name);
          return next({
            name: 'dashboard'
          })
        }, 100)
      }
      else{
        router.app.$store.dispatch("SET_LAYOUT", to.name);
        return next()
      }
    }
    router.app.$store.dispatch("SET_LAYOUT", to.name);
    return next()
  });
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js